import memoize from "lodash.memoize";

const isElementSizeType = (data) =>
  typeof data === "object" && (Object.hasOwnProperty.call(data, "width") || Object.hasOwnProperty.call(data, "height"));

/**
 * This function is responsible for getting the proper size of elements based on the screen size.
 * Its purpose is to have elements scale regardless of the screen size/resolution.
 *
 * The base resolution for scaling is 1920x1080. That means that if element is 100x200 (this will
 * be also treated as getSize args) for the device with 1920x1080 resolution, it will be scaled
 * down to 66.67x133.33 for 1280x720 devices.
 *
 * @param {number} size
 * @param elementSize
 * @param {number} size.width
 * @param {number} size.height
 *
 * @returns {number} or {width: number, height: number}, depending on the passed param
 */
export const getSize = memoize((size) => {
  const { clientHeight, clientWidth } = document.body;
  const referenceHeight = 1080;
  const referenceWidth = 1920;

  if (!isElementSizeType(size)) {
    return Number(((size * clientWidth) / referenceWidth).toFixed(2));
  } else {
    const { width, height } = size;
    return {
      width: Number(((width * clientWidth) / referenceWidth).toFixed(2)),
      height: Number(((height * clientHeight) / referenceHeight).toFixed(2)),
    };
  }
});
